import { lazy } from 'react';

// Every page is loaded on demand, so a visitor landing on the marketing site
// never downloads the dashboard bundle.
export const LandingPage = lazy(() =>
  import('@/features/landing/pages/LandingPage').then((m) => ({ default: m.LandingPage })),
);
export const FeaturesPage = lazy(() =>
  import('@/features/marketing/pages/FeaturesPage').then((m) => ({ default: m.FeaturesPage })),
);
export const PricingPage = lazy(() =>
  import('@/features/marketing/pages/PricingPage').then((m) => ({ default: m.PricingPage })),
);
export const ExplorePage = lazy(() =>
  import('@/features/catalog/pages/ExplorePage').then((m) => ({ default: m.ExplorePage })),
);
export const MasterProfilePage = lazy(() =>
  import('@/features/masters/pages/MasterProfilePage').then((m) => ({
    default: m.MasterProfilePage,
  })),
);
export const AuthPage = lazy(() =>
  import('@/features/auth/pages/AuthPage').then((m) => ({ default: m.AuthPage })),
);
export const ResetPasswordPage = lazy(() =>
  import('@/features/auth/pages/ResetPasswordPage').then((m) => ({
    default: m.ResetPasswordPage,
  })),
);
export const ClientAuthPage = lazy(() =>
  import('@/features/auth/pages/ClientAuthPage').then((m) => ({ default: m.ClientAuthPage })),
);
export const InfoPage = lazy(() =>
  import('@/features/marketing/pages/InfoPage').then((m) => ({ default: m.InfoPage })),
);
export const NotFoundPage = lazy(() =>
  import('@/features/marketing/pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);

export const ClientDashboardPage = lazy(() =>
  import('@/features/client-hub/pages/ClientDashboardPage').then((m) => ({
    default: m.ClientDashboardPage,
  })),
);
export const ClientBookingsPage = lazy(() =>
  import('@/features/client-hub/pages/ClientBookingsPage').then((m) => ({
    default: m.ClientBookingsPage,
  })),
);
export const ClientFavoritesPage = lazy(() =>
  import('@/features/client-hub/pages/ClientFavoritesPage').then((m) => ({
    default: m.ClientFavoritesPage,
  })),
);
export const ClientProfilePage = lazy(() =>
  import('@/features/client-hub/pages/ClientProfilePage').then((m) => ({
    default: m.ClientProfilePage,
  })),
);

export const DashboardPage = lazy(() =>
  import('@/features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })),
);
export const OnboardingWizardPage = lazy(() =>
  import('@/features/onboarding/pages/OnboardingWizardPage').then((m) => ({
    default: m.OnboardingWizardPage,
  })),
);
export const CalendarPage = lazy(() =>
  import('@/features/calendar/pages/CalendarPage').then((m) => ({ default: m.CalendarPage })),
);
export const NotificationsPage = lazy(() =>
  import('@/features/notifications/pages/NotificationsPage').then((m) => ({
    default: m.NotificationsPage,
  })),
);
export const TeamPage = lazy(() =>
  import('@/features/team/pages/TeamPage').then((m) => ({ default: m.TeamPage })),
);
export const TeamJoinPage = lazy(() =>
  import('@/features/team/pages/TeamJoinPage').then((m) => ({ default: m.TeamJoinPage })),
);
export const ClientsPage = lazy(() =>
  import('@/features/clients/pages/ClientsPage').then((m) => ({ default: m.ClientsPage })),
);
export const ReviewsPage = lazy(() =>
  import('@/features/reviews/pages/ReviewsPage').then((m) => ({ default: m.ReviewsPage })),
);
export const AnalyticsPage = lazy(() =>
  import('@/features/analytics/pages/AnalyticsPage').then((m) => ({ default: m.AnalyticsPage })),
);
export const ServicesPage = lazy(() =>
  import('@/features/services/pages/ServicesPage').then((m) => ({ default: m.ServicesPage })),
);
export const PortfolioPage = lazy(() =>
  import('@/features/portfolio/pages/PortfolioPage').then((m) => ({ default: m.PortfolioPage })),
);
export const SettingsProfilePage = lazy(() =>
  import('@/features/settings/pages/SettingsProfilePage').then((m) => ({
    default: m.SettingsProfilePage,
  })),
);
export const SettingsSchedulePage = lazy(() =>
  import('@/features/settings/pages/SettingsSchedulePage').then((m) => ({
    default: m.SettingsSchedulePage,
  })),
);
export const SettingsNotificationsPage = lazy(() =>
  import('@/features/settings/pages/SettingsNotificationsPage').then((m) => ({
    default: m.SettingsNotificationsPage,
  })),
);
export const SettingsSubscriptionPage = lazy(() =>
  import('@/features/settings/pages/SettingsSubscriptionPage').then((m) => ({
    default: m.SettingsSubscriptionPage,
  })),
);
export const SettingsPrivacyPage = lazy(() =>
  import('@/features/privacy/pages/SettingsPrivacyPage').then((m) => ({
    default: m.SettingsPrivacyPage,
  })),
);
export const ComparisonPage = lazy(() =>
  import('@/features/comparison/pages/ComparisonPage').then((m) => ({ default: m.ComparisonPage })),
);
